export default __webpack_public_path__ + "static/media/banners_diademuertos_medico_330x330(3).07bc946e.jpg";